import { configureStore } from '@reduxjs/toolkit'
import authSlice from './features/auth'
import stateSlice from './features/state'
import categoriesSlice from './features/categories'
import couponsSlice from './features/coupons'
import productsSlice from './features/products'
import contactSlice from './features/contact'
import usersSlice from './features/users'
import customersSlice from './features/customers'
import ordersSlice from './features/orders'
import notificationsSlice from './features/notifications'

export const store = configureStore({
	reducer: {
		auth: authSlice,
		state: stateSlice,
		categories: categoriesSlice,
		coupons: couponsSlice,
		products: productsSlice,
		contacts: contactSlice,
		users: usersSlice,
		customers: customersSlice,
		orders: ordersSlice,
		notifications: notificationsSlice,
	},
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
